import CheckBoxGroup from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxGroup'
import CheckBoxInput from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInput'
import CheckBoxInputSet from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInputSet'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxLabel'
import type { Prefecture } from '@pc/components/Works/Panel/types'
import type { ChangeEvent, ChangeEventHandler, ComponentPropsWithoutRef } from 'react'

interface PropsType {
  prefecture: Prefecture
  cities: Prefecture[]
  selectedCityIds: string[]
  changeCityIds: (arg: string[]) => void
}

const CheckBoxAreaInputSet = (props: ComponentPropsWithoutRef<'li'>) => <CheckBoxInputSet className="w-1/4" {...props} />

const renderCityCheckboxes = (cities: Prefecture[], selectedCityIds: string[], toggleCheckbox: ChangeEventHandler) => {
  return cities.map((city) => {
    const CityId = `city-${city.id}`
    return (
      <CheckBoxAreaInputSet key={CityId}>
        <CheckBoxInput
          type="checkbox"
          id={CityId}
          value={city.attributes.compat_id}
          onChange={toggleCheckbox}
          checked={selectedCityIds.includes(String(city.attributes.compat_id))}
        />
        <CheckBoxLabel htmlFor={CityId}>{city.attributes.name}</CheckBoxLabel>
      </CheckBoxAreaInputSet>
    )
  })
}

const AreaBox = (props: PropsType) => {
  const { prefecture, cities, selectedCityIds, changeCityIds } = props

  const toggleCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    const cityId = e.target.value

    if (e.target.checked) {
      const concatedCityIds = selectedCityIds.concat(cityId)
      changeCityIds(concatedCityIds)
    } else {
      const filteredCityIds = selectedCityIds.filter((selectedCityId) => selectedCityId !== cityId)
      changeCityIds(filteredCityIds)
    }
  }

  const toggleAllCheckbox = () => {
    if (isAllSelected()) {
      changeCityIds([])
    } else {
      const cityCompatIds = cities.map((city) => city.attributes.compat_id.toString())
      changeCityIds([...new Set([...selectedCityIds.concat(cityCompatIds)])])
    }
  }

  const isAllSelected = () => {
    return selectedCityIds.length === cities.length
  }

  return (
    <div className="absolute top-17 bottom-21 left-0 w-full overflow-y-hidden border-t border-b border-gray-500 px-5 py-4">
      <div className="h-full overflow-x-hidden overflow-y-scroll">
        <CheckBoxGroup>
          <CheckBoxInputSet>
            <CheckBoxInput type="checkbox" id="rootCity" onChange={toggleAllCheckbox} checked={isAllSelected()} />
            <CheckBoxLabel htmlFor="rootCity">{prefecture.attributes.name}内のエリア全て</CheckBoxLabel>
          </CheckBoxInputSet>
        </CheckBoxGroup>
        <CheckBoxGroup>{renderCityCheckboxes(cities, selectedCityIds, toggleCheckbox)}</CheckBoxGroup>
      </div>
    </div>
  )
}

export default AreaBox
